import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles({
  heading: {
    position: "relative",
    alignSelf: "center",
    justifySelf: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    lineHeight: "normal",
    width: "fit-content",
    height: "auto",
    margin: "0 auto",
    color: "#fafafa",
    fontWeight: "300",
    zIndex: "999",
  },

  heading__line1: {
    animationName: "moveInLeft",
    fontSize: "6rem",
    fontWeight: "600",
    letterSpacing: "0.4rem",
    animationDuration: "5.4s",
    backgroundColor: "rgba(26, 26, 26, 0.25)",
    animationTimingFunction: "cubic-bezier(0.21, 1.11, 0.81, 0.99)",
    transition: "0.5s",
    "&:hover": {
      color: "#EFFBFF",
      "& span": {
        color: "#FFFFFF",
        textShadow:
          "0 0 8px #fff, 0 0 15px #fff, 0 0 30px #fff, 0 0 70px rgba(255, 255, 255, 0.041), 0 0 120px #fff, 0 0 150px #BAE8E8",
        "&:nth-child(1)": {
          marginRight: "1rem",
        },
        "&:nth-child(2)": {
          marginLeft: "1rem",
        },
      },
    },
  },

  devName: {
    color: "#ff4d5a",
    fontWeight: "700",
  },

  heading__line2: {
    animationName: "moveInRight",
    fontFamily: "Orbitron, sans-serif",
    fontSize: "2.2rem",
    letterSpacing: "0.3rem",
    animationDuration: "10s",
    backgroundColor: "rgba(26, 26, 26, 0.25)",
    animationTimingFunction: "cubic-bezier(0.21, 1.11, 0.81, 0.99)",
    "& span": {
      fontSize: "1.4rem",
      color: "chartreuse",
    },
  },
});

function Heading() {
  const classes = useStyles();
  return (
    <>
      {/* <!-- Heading home page START--> */}
      <div className={`${classes.heading} noselect`}>
        <div className={classes.heading__line1}>
          <span>I</span>'m<span className={classes.devName}> Touhid Alam</span>.
        </div>
        <div className={classes.heading__line2}>
          Web Developer
          <span>
            <small> JavaScript / React / MERN Stack</small>
          </span>
        </div>
      </div>
      {/* <!-- Heading home page END --> */}
    </>
  );
}

export default Heading;
